var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.627 3.5v.184c0 1.835-.003 3.669.002 5.503a2.167 2.167 0 0 0 1.73 2.139c.18.039.37.047.555.047l2.702.002H10.5c0 .137.002.261 0 .385-.007.383.02.77-.03 1.146-.081.637-.627 1.089-1.273 1.095-.569.006-1.138.002-1.707.002H1.4c-.848 0-1.4-.554-1.4-1.403V4.9C0 4.052.554 3.5 1.403 3.5h1.224ZM12.6 0c.85 0 1.4.551 1.4 1.402v7.7c0 .848-.553 1.4-1.402 1.4H4.9c-.847 0-1.4-.554-1.4-1.402V1.4C3.5.552 4.053 0 4.902 0H12.6Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClone);
export default ForwardRef;